package pl.decks.personal.extensions

import com.varabyte.kobweb.compose.ui.graphics.Color

fun Color.blend(other: Color, fraction: Float): Color.Rgb {
    val rgb = this.toRgb()
    val otherRgb = other.toRgb()
    return Color.rgb(
        r = (rgb.red * (1 - fraction) + otherRgb.red * fraction).toInt(),
        g = (rgb.green * (1 - fraction) + otherRgb.green * fraction).toInt(),
        b = (rgb.blue * (1 - fraction) + otherRgb.blue * fraction).toInt(),
    )
}
